/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { CluUtteranceSwagger } from 'src/clu/core/services/cluUtteranceSwagger';
import { CluGptPredictedUtteranceStore } from 'src/clu/core/stores/CluGptPredictedUtteranceStore';
import { ProgressTrackerStore } from 'src/core/stores/ProgressTrackerStore';
import { OmitFunctions } from 'src/core/stores/types';

export type CluGptPredictionsStoreData = OmitFunctions<CluGptPredictionsStore>;

export class CluGptPredictionsStore {
    @observable public isDirty: boolean;

    @observable public rawUtterances: CluUtteranceSwagger[];

    @observable public acceptedUtterances: CluGptPredictedUtteranceStore[];

    @observable public rejectedUtterances: CluGptPredictedUtteranceStore[];

    public tracker: ProgressTrackerStore;

    constructor(data?: CluGptPredictionsStoreData) {
        this.acceptedUtterances = [];
        this.rejectedUtterances = [];
        this.isDirty = data?.isDirty ?? false;
        this.tracker = new ProgressTrackerStore();
        this.rawUtterances = data?.rawUtterances ?? [];
    }

    @action
    public setIsDirty(isDirty: boolean) {
        this.isDirty = isDirty;
    }

    @action
    public setRawUtterances(utterances: CluUtteranceSwagger[]) {
        this.rawUtterances = utterances;
    }

    @action
    public setAcceptedUtterances(utterances: CluGptPredictedUtteranceStore[]) {
        this.isDirty = true;
        this.acceptedUtterances = utterances;
    }

    @action
    public setRejectedUtterances(utterances: CluGptPredictedUtteranceStore[]) {
        this.isDirty = true;
        this.rejectedUtterances = utterances;
    }
}
